import UpdateDesignationForm from 'components/form/super-admin/master/designation/UpdateDesignationForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class UpdateDesignation extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Update Designation</h4>
                              <UpdateDesignationForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
